export default function AboutUs() {
  return (
    <div className="min-h-screen pt-[72px]">
      <div className="container-page section-py">
        <h1 className="text-4xl font-bold">Hakkımızda</h1>
        <p className="mt-4 text-foreground-500">Sayfa yapım aşamasında...</p>
      </div>
    </div>
  );
}